import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraText } from '@mono/ui-components/ensigns';
import { SpecraCombobox } from '@mono/ui-components/lieutenants';
import { useState } from 'react';
/** More → "Replace with a project file…" → `ImportDocxVersion` (a new version, History keeps the old one). */ export function ReplaceFromFileDialog({ onOpenChange, onReplace, open, sources, unitNoun }) {
    const [picked, setPicked] = useState();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState(null);
    const source = sources.find((s)=>s.id === picked);
    const confirm = async ()=>{
        if (!source || pending) return;
        setPending(true);
        setError(null);
        try {
            await onReplace(source);
            onOpenChange(false);
            setPicked(undefined);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'The file could not be imported.');
        } finally{
            setPending(false);
        }
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        description: `The ${unitNoun === 'answer' ? 'response' : 'volume'} document becomes this file as a new version. The current version stays in History.`,
        footerProps: {
            confirmLabel: 'Replace',
            confirmDisabled: !source,
            loading: pending,
            loadingLabel: 'Replacing…',
            onCancel: ()=>onOpenChange(false),
            onConfirm: confirm
        },
        onOpenChange: onOpenChange,
        open: open,
        size: "sm",
        title: "Replace with a project file",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-[var(--space-3)]",
            children: [
                /*#__PURE__*/ _jsx(SpecraCombobox, {
                    emptyMessage: "No .docx files in this project.",
                    label: "Project file",
                    onValueChange: setPicked,
                    options: sources.map((s)=>({
                            value: s.id,
                            label: s.label,
                            description: s.description
                        })),
                    placeholder: "Choose a .docx file",
                    value: picked
                }),
                error ? /*#__PURE__*/ _jsx(SpecraText, {
                    role: "alert",
                    size: "caption",
                    tone: "danger",
                    children: error
                }) : null
            ]
        })
    });
}
